module.exports = __webpack_public_path__ + "img/avatar6.c0427177.png";